import { hasValue } from '@famly/stat_ts-utils_has-value';
import { readServerErrorObject } from './read-server-error-object';
/**
 * The `core` PHP error a failed REST request returned, or `null` when its body is not one.
 */
export const readRestError = (error) => {
    const body = readServerErrorObject(error);
    return hasValue(body) && hasValue(body.error) && hasValue(body.errorCode) && hasValue(body.log)
        ? body
        : null;
};
